import { schema } from "normalizr";
import { FileExport as FileExportRecord } from "records/files";

export const FileExport = new schema.Entity(
    "fileExport",
    {},
    {
        idAttribute: "id",
    }
);

(FileExport as any).record = FileExportRecord;
